module.exports = __webpack_public_path__ + "img/successful.5db45352.png";